import React, { useState, useEffect, useRef } from "react";
import { useData } from "../context/DataContext";

// ─── Admin Login Gate ─────────────────────────────────────
function AdminLogin({ onLogin }) {
  const { login } = useData();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const result = await login(form.username, form.password);
    if (result.ok) {
      onLogin();
    } else {
      setError(result.message || "Credenciales incorrectas");
    }
    setLoading(false);
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-box">
        <h1>enramá</h1>
        <p>Panel de administración</p>
        <form className="admin-login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Usuario"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            autoComplete="username"
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            autoComplete="current-password"
          />
          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? "Autenticando…" : "Entrar"}
          </button>
        </form>
        {error && <p className="admin-login-error">⚠ {error}</p>}
      </div>
    </div>
  );
}

// ─── Product Form Modal ───────────────────────────────────
function ProductForm({ product, onSave, onCancel }) {
  const { API } = useData();
  const [form, setForm] = useState({
    name: product?.name || "",
    price: product?.price || "",
    launchPrice: product?.launchPrice || "",
    useLaunchPrice: product?.useLaunchPrice ? "true" : "false",
    info: product?.info || "",
    material: product?.material || "",
    dimensiones: product?.dimensiones || "",
    featured: product?.featured ? "true" : "false",
  });
  const [mainImage, setMainImage] = useState(null);
  const [extraImages, setExtraImages] = useState([]);
  
  const [colorIcon1, setColorIcon1] = useState(null);
  const [colorIcon2, setColorIcon2] = useState(null);
  const [colorIcon3, setColorIcon3] = useState(null);

  const [woodName1, setWoodName1] = useState("");
  const [woodName2, setWoodName2] = useState("");
  const [woodName3, setWoodName3] = useState("");

  const [woodPrice1, setWoodPrice1] = useState("");
  const [woodPrice2, setWoodPrice2] = useState("");
  const [woodPrice3, setWoodPrice3] = useState("");

  const [woodLaunchPrice1, setWoodLaunchPrice1] = useState("");
  const [woodLaunchPrice2, setWoodLaunchPrice2] = useState("");
  const [woodLaunchPrice3, setWoodLaunchPrice3] = useState("");

  useEffect(() => {
    if (product?.colors) {
      const getWoodName = (val) => {
        if (!val) return "";
        if (typeof val === 'string') return "";
        return val.name || "";
      };
      const getWoodPrice = (val) => {
        if (!val) return "";
        if (typeof val === 'string') return "";
        return val.price || "";
      };
      const getWoodLaunchPrice = (val) => {
        if (!val) return "";
        if (typeof val === 'string') return "";
        return val.launchPrice || "";
      };
      setWoodName1(getWoodName(product.colors[0]));
      setWoodName2(getWoodName(product.colors[1]));
      setWoodName3(getWoodName(product.colors[2]));

      setWoodPrice1(getWoodPrice(product.colors[0]));
      setWoodPrice2(getWoodPrice(product.colors[1]));
      setWoodPrice3(getWoodPrice(product.colors[2]));

      setWoodLaunchPrice1(getWoodLaunchPrice(product.colors[0]));
      setWoodLaunchPrice2(getWoodLaunchPrice(product.colors[1]));
      setWoodLaunchPrice3(getWoodLaunchPrice(product.colors[2]));
    } else {
      setWoodName1("");
      setWoodName2("");
      setWoodName3("");
      setWoodPrice1("");
      setWoodPrice2("");
      setWoodPrice3("");
      setWoodLaunchPrice1("");
      setWoodLaunchPrice2("");
      setWoodLaunchPrice3("");
    }
  }, [product]);

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.price.trim()) {
      setError("Nombre y precio son obligatorios.");
      return;
    }
    setSaving(true);
    setError("");

    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    if (mainImage) fd.append("image", mainImage);
    extraImages.forEach((img) => fd.append("images", img));

    if (colorIcon1) fd.append("colorIcon1", colorIcon1);
    if (colorIcon2) fd.append("colorIcon2", colorIcon2);
    if (colorIcon3) fd.append("colorIcon3", colorIcon3);

    fd.append("woodName1", woodName1);
    fd.append("woodName2", woodName2);
    fd.append("woodName3", woodName3);

    fd.append("woodPrice1", woodPrice1);
    fd.append("woodPrice2", woodPrice2);
    fd.append("woodPrice3", woodPrice3);

    fd.append("woodLaunchPrice1", woodLaunchPrice1);
    fd.append("woodLaunchPrice2", woodLaunchPrice2);
    fd.append("woodLaunchPrice3", woodLaunchPrice3);

    const result = await onSave(fd);
    if (!result.ok) setError(result.message || "Error al guardar");
    setSaving(false);
  };

  return (
    <div className="admin-form-overlay" onClick={onCancel}>
      <div className="admin-form-box" onClick={(e) => e.stopPropagation()}>
        <h3>{product ? "Editar producto" : "Nuevo producto"}</h3>
        <form className="admin-form" onSubmit={handleSubmit}>
          <div>
            <label>Nombre *</label>
            <input name="name" value={form.name} onChange={handleChange} placeholder="Ej: Mecedora" />
          </div>
          <div>
            <label>Precio Base *</label>
            <input name="price" value={form.price} onChange={handleChange} placeholder="Ej: $20,000" />
          </div>
          <div>
            <label>Precio de Lanzamiento (Opcional)</label>
            <input name="launchPrice" value={form.launchPrice} onChange={handleChange} placeholder="Ej: $18,000" />
          </div>
          <div>
            <label>Activar Precio de Lanzamiento</label>
            <select name="useLaunchPrice" value={form.useLaunchPrice} onChange={handleChange}>
              <option value="false">No</option>
              <option value="true">Sí — tachar precio base y mostrar este</option>
            </select>
          </div>
          <div>
            <label>Material</label>
            <input name="material" value={form.material} onChange={handleChange} placeholder="Ej: Madera de roble" />
          </div>
          <div>
            <label>Dimensiones</label>
            <input name="dimensiones" value={form.dimensiones} onChange={handleChange} placeholder="Ej: 60cm x 80cm x 100cm" />
          </div>
          <div>
            <label>Descripción</label>
            <textarea name="info" value={form.info} onChange={handleChange} placeholder="Descripción del producto…" rows={3} />
          </div>
          <div>
            <label>Destacado</label>
            <select name="featured" value={form.featured} onChange={handleChange}>
              <option value="true">Sí — mostrar en página principal</option>
              <option value="false">No</option>
            </select>
          </div>
          <div>
            <label>Imagen principal</label>
            <input type="file" accept="image/*" onChange={(e) => setMainImage(e.target.files[0])} />
          </div>
          <div>
            <label>Imágenes adicionales (carrusel)</label>
            <input type="file" accept="image/*" multiple onChange={(e) => setExtraImages([...e.target.files])} />
          </div>

          <div className="admin-colors-section">
            <h4>Iconos de Maderas Disponibles (Hasta 3)</h4>
            <div className="admin-colors-grid">
              {[0, 1, 2].map((idx) => {
                const getIconPath = (val) => {
                  if (!val) return null;
                  if (typeof val === 'string') return val;
                  return val.icon || null;
                };
                const colorIconPath = getIconPath(product?.colors?.[idx]);
                const setIcon = [setColorIcon1, setColorIcon2, setColorIcon3][idx];
                const iconVal = [colorIcon1, colorIcon2, colorIcon3][idx];
                
                const nameVal = [woodName1, woodName2, woodName3][idx];
                const setName = [setWoodName1, setWoodName2, setWoodName3][idx];
                const priceVal = [woodPrice1, woodPrice2, woodPrice3][idx];
                const setPrice = [setWoodPrice1, setWoodPrice2, setWoodPrice3][idx];
                const launchPriceVal = [woodLaunchPrice1, woodLaunchPrice2, woodLaunchPrice3][idx];
                const setLaunchPrice = [setWoodLaunchPrice1, setWoodLaunchPrice2, setWoodLaunchPrice3][idx];

                return (
                  <div key={idx} className="admin-color-col">
                    <h5>Madera {idx + 1}</h5>
                    
                    {colorIconPath && (
                      <div className="admin-existing-color-previews">
                        <div className="admin-existing-color-preview-item">
                          <span>Icono:</span>
                          <img src={`${API}${colorIconPath}`} alt={`Icono ${idx+1}`} />
                        </div>
                      </div>
                    )}

                    <div className="admin-file-input-group">
                      <label>Icono de madera</label>
                      <input 
                        type="file" 
                        accept="image/*" 
                        onChange={(e) => setIcon(e.target.files[0])} 
                      />
                      {iconVal && <span className="file-selected">✓ {iconVal.name}</span>}
                    </div>

                    <div className="admin-file-input-group">
                      <label>Nombre de la madera</label>
                      <input 
                        type="text" 
                        placeholder="Ej: Roble"
                        value={nameVal}
                        onChange={(e) => setName(e.target.value)} 
                      />
                    </div>

                    <div className="admin-file-input-group">
                      <label>Precio de la madera</label>
                      <input 
                        type="text" 
                        placeholder="Ej: $37,000.00"
                        value={priceVal}
                        onChange={(e) => setPrice(e.target.value)} 
                      />
                    </div>

                    <div className="admin-file-input-group">
                      <label>Precio de lanzamiento (Madera)</label>
                      <input 
                        type="text" 
                        placeholder="Ej: $35,000.00"
                        value={launchPriceVal}
                        onChange={(e) => setLaunchPrice(e.target.value)} 
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {error && <p style={{ color: "var(--clr-error)", fontSize: "0.85rem" }}>⚠ {error}</p>}

          <div className="admin-form-actions">
            <button type="button" className="admin-cancel-btn" onClick={onCancel}>Cancelar</button>
            <button type="submit" className="admin-save-btn" disabled={saving}>
              {saving ? "Guardando…" : "Guardar producto"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function PostForm({ post, onSave, onCancel }) {
  const [form, setForm] = useState({
    title: post?.title || "",
    excerpt: post?.excerpt || "",
    content: post?.content || "",
    author: post?.author || "Enramá",
    tags: post?.tags?.join(", ") || "",
  });
  const [coverImage, setCoverImage] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const textareaRef = useRef(null);
  const { API, adminToken } = useData();
  const [uploadingImage, setUploadingImage] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showCarouselModal, setShowCarouselModal] = useState(false);
  const [showDoubleImageModal, setShowDoubleImageModal] = useState(false);
  const [imgMeta, setImgMeta] = useState({
    title: "",
    author: "",
    details: "",
    file: null,
  });

  const handleInsertHtml = (htmlString) => {
    const textarea = textareaRef.current;
    if (textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = textarea.value;

      const newContent = text.substring(0, start) + htmlString + text.substring(end);
      setForm((prev) => ({ ...prev, content: newContent }));

      setTimeout(() => {
        textarea.focus();
        textarea.selectionStart = textarea.selectionEnd = start + htmlString.length;
      }, 50);
    } else {
      setForm((prev) => ({ ...prev, content: prev.content + htmlString }));
    }
  };

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleInsertImageClick = () => {
    setImgMeta({
      title: "",
      author: "",
      details: "",
      file: null,
    });
    setShowImageModal(true);
  };

  const handleImageUploadWithMeta = async () => {
    if (!imgMeta.file) return;
    setUploadingImage(true);
    setError("");

    const fd = new FormData();
    fd.append("file", imgMeta.file);

    try {
      const res = await fetch(`${API}/api/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
        body: fd,
      });

      if (res.ok) {
        const data = await res.json();
        const textarea = textareaRef.current;
        if (textarea) {
          const start = textarea.selectionStart;
          const end = textarea.selectionEnd;
          const text = textarea.value;

          let captionText = "";
          if (imgMeta.title.trim()) {
            captionText += `<strong>${imgMeta.title.trim()}</strong>`;
          }
          if (imgMeta.author.trim()) {
            captionText += captionText ? ` — Foto por ${imgMeta.author.trim()}` : `Foto por ${imgMeta.author.trim()}`;
          }
          if (imgMeta.details.trim()) {
            captionText += captionText 
              ? `. <span style="font-size: 0.8rem; display: block; opacity: 0.8; margin-top: 2px;">${imgMeta.details.trim()}</span>`
              : `<span style="font-size: 0.8rem; display: block; opacity: 0.8; margin-top: 2px;">${imgMeta.details.trim()}</span>`;
          }

          const figcaptionHtml = captionText 
            ? `\n  <figcaption style="font-size: 0.85rem; color: var(--clr-bark-light); line-height: 1.4; font-style: italic; max-width: 600px; margin: 0.5rem auto 0; text-align: center;">${captionText}</figcaption>`
            : "";

          const imgTag = `\n<figure style="margin: 2rem auto; max-width: 100%; display: block; text-align: center;">\n  <img src="${data.url}" style="display:block; max-width:100%; height:auto; margin:0 auto; border-radius:8px;" alt="${imgMeta.title.trim() || "imagen"}" />${figcaptionHtml}\n</figure>\n`;

          const newContent = text.substring(0, start) + imgTag + text.substring(end);
          setForm((prev) => ({ ...prev, content: newContent }));

          setTimeout(() => {
            textarea.focus();
            textarea.selectionStart = textarea.selectionEnd = start + imgTag.length;
          }, 50);
        }
        setShowImageModal(false);
      } else {
        setError("Error al subir la imagen.");
      }
    } catch (err) {
      console.error(err);
      setError("Error de red al subir la imagen.");
    } finally {
      setUploadingImage(false);
    }
  };

  const handleInsertBold = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = textarea.value;
      const selected = text.substring(start, end);

      const boldTag = `<strong>${selected || "texto en negrita"}</strong>`;
      const newContent = text.substring(0, start) + boldTag + text.substring(end);

      setForm((prev) => ({ ...prev, content: newContent }));

      setTimeout(() => {
        textarea.focus();
        if (selected) {
          textarea.selectionStart = start;
          textarea.selectionEnd = start + boldTag.length;
        } else {
          textarea.selectionStart = start + 8;
          textarea.selectionEnd = start + 8 + 17;
        }
      }, 50);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.content.trim()) {
      setError("Título y contenido son obligatorios.");
      return;
    }
    setSaving(true);
    setError("");

    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    if (coverImage) fd.append("coverImage", coverImage);

    const result = await onSave(fd);
    if (!result.ok) setError(result.message || "Error al guardar");
    setSaving(false);
  };

  return (
    <div className="admin-form-overlay" onClick={onCancel}>
      <div className="admin-form-box" onClick={(e) => e.stopPropagation()}>
        <h3>{post ? "Editar publicación" : "Nueva publicación"}</h3>
        <form className="admin-form" onSubmit={handleSubmit}>
          <div>
            <label>Título *</label>
            <input name="title" value={form.title} onChange={handleChange} placeholder="Título del post" />
          </div>
          <div>
            <label>Extracto (resumen)</label>
            <textarea name="excerpt" value={form.excerpt} onChange={handleChange} placeholder="Breve descripción…" rows={2} />
          </div>
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
              <label style={{ marginBottom: 0 }}>Contenido *</label>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                <button
                  type="button"
                  className="admin-add-btn"
                  onClick={handleInsertBold}
                  style={{
                    fontSize: "0.8rem",
                    padding: "4px 10px",
                    margin: 0,
                    height: "auto",
                    lineHeight: 1.2
                  }}
                >
                  <strong>B</strong> Negrita
                </button>
                <button
                  type="button"
                  className="admin-add-btn"
                  onClick={handleInsertImageClick}
                  style={{
                    fontSize: "0.8rem",
                    padding: "4px 10px",
                    margin: 0,
                    height: "auto",
                    lineHeight: 1.2
                  }}
                >
                  🖼 Imagen
                </button>
                <button
                  type="button"
                  className="admin-add-btn"
                  onClick={() => setShowCarouselModal(true)}
                  style={{
                    fontSize: "0.8rem",
                    padding: "4px 10px",
                    margin: 0,
                    height: "auto",
                    lineHeight: 1.2
                  }}
                >
                  🎠 Carrusel
                </button>
                <button
                  type="button"
                  className="admin-add-btn"
                  onClick={() => setShowDoubleImageModal(true)}
                  style={{
                    fontSize: "0.8rem",
                    padding: "4px 10px",
                    margin: 0,
                    height: "auto",
                    lineHeight: 1.2
                  }}
                >
                  👥 2 Fotos
                </button>
              </div>
            </div>
            <textarea
              ref={textareaRef}
              name="content"
              value={form.content}
              onChange={handleChange}
              placeholder="Escribe el contenido completo…"
              rows={12}
            />
          </div>
          <div>
            <label>Autor</label>
            <input name="author" value={form.author} onChange={handleChange} />
          </div>
          <div>
            <label>Etiquetas (separadas por coma)</label>
            <input name="tags" value={form.tags} onChange={handleChange} placeholder="artesanía, tradición, diseño" />
          </div>
          <div>
            <label>Imagen de portada</label>
            <input type="file" accept="image/*" onChange={(e) => setCoverImage(e.target.files[0])} />
          </div>

          {error && <p style={{ color: "var(--clr-error)", fontSize: "0.85rem" }}>⚠ {error}</p>}

          <div className="admin-form-actions">
            <button type="button" className="admin-cancel-btn" onClick={onCancel}>Cancelar</button>
            <button type="submit" className="admin-save-btn" disabled={saving}>
              {saving ? "Guardando…" : "Guardar publicación"}
            </button>
          </div>
        </form>
      </div>

      {/* Sub-modal for adding image with metadata */}
      {showImageModal && (
        <div className="admin-form-overlay" style={{ zIndex: 1010 }} onClick={() => setShowImageModal(false)}>
          <div className="admin-form-box" style={{ maxWidth: 400 }} onClick={(e) => e.stopPropagation()}>
            <h4 style={{ marginBottom: 16, fontFamily: "var(--font-heading)" }}>Insertar Imagen con Detalles</h4>
            
            <div className="admin-form">
              <div>
                <label style={{ fontSize: "0.8rem" }}>Título de la fotografía</label>
                <input 
                  type="text" 
                  value={imgMeta.title} 
                  onChange={(e) => setImgMeta({ ...imgMeta, title: e.target.value })} 
                  placeholder="Ej. Silla tejida de perfil" 
                />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem" }}>Autor de la foto</label>
                <input 
                  type="text" 
                  value={imgMeta.author} 
                  onChange={(e) => setImgMeta({ ...imgMeta, author: e.target.value })} 
                  placeholder="Ej. Juan Pérez" 
                />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem" }}>Detalles adicionales</label>
                <input 
                  type="text" 
                  value={imgMeta.details} 
                  onChange={(e) => setImgMeta({ ...imgMeta, details: e.target.value })} 
                  placeholder="Ej. Junio 2026, Santo Domingo" 
                />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem" }}>Seleccionar archivo *</label>
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={(e) => setImgMeta({ ...imgMeta, file: e.target.files[0] })} 
                />
              </div>
              
              <div className="admin-form-actions" style={{ marginTop: 24 }}>
                <button 
                  type="button" 
                  className="admin-cancel-btn" 
                  onClick={() => setShowImageModal(false)}
                >
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="admin-save-btn" 
                  onClick={handleImageUploadWithMeta}
                  disabled={uploadingImage || !imgMeta.file}
                >
                  {uploadingImage ? "Subiendo..." : "Insertar"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCarouselModal && (
        <CarouselModal
          API={API}
          adminToken={adminToken}
          onInsert={handleInsertHtml}
          onClose={() => setShowCarouselModal(false)}
        />
      )}

      {showDoubleImageModal && (
        <DoubleImageModal
          API={API}
          adminToken={adminToken}
          onInsert={handleInsertHtml}
          onClose={() => setShowDoubleImageModal(false)}
        />
      )}
    </div>
  );
}

// ─── Carousel Modal Helper ────────────────────────────────────
function CarouselModal({ onInsert, onClose, API, adminToken }) {
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState("");
  const [error, setError] = useState("");

  const handleAddImages = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      id: Math.random().toString(),
      file,
      preview: URL.createObjectURL(file),
      caption: "",
    }));
    setImages((prev) => [...prev, ...newImages]);
  };

  const handleRemoveImage = (id) => {
    setImages((prev) => {
      const target = prev.find((img) => img.id === id);
      if (target && target.preview) {
        URL.revokeObjectURL(target.preview);
      }
      return prev.filter((img) => img.id !== id);
    });
  };

  const handleCaptionChange = (id, text) => {
    setImages((prev) =>
      prev.map((img) => (img.id === id ? { ...img, caption: text } : img))
    );
  };

  const handleMove = (index, direction) => {
    const nextIndex = index + direction;
    if (nextIndex < 0 || nextIndex >= images.length) return;
    const newImages = [...images];
    const temp = newImages[index];
    newImages[index] = newImages[nextIndex];
    newImages[nextIndex] = temp;
    setImages(newImages);
  };

  const handleSubmit = async () => {
    if (images.length === 0) {
      setError("Por favor, selecciona al menos una imagen.");
      return;
    }

    setUploading(true);
    setError("");

    try {
      const uploadedSlides = [];
      for (let i = 0; i < images.length; i++) {
        const img = images[i];
        setUploadProgress(`Subiendo imagen ${i + 1} de ${images.length}...`);

        const fd = new FormData();
        fd.append("file", img.file);

        const res = await fetch(`${API}/api/upload`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${adminToken}`,
          },
          body: fd,
        });

        if (!res.ok) {
          throw new Error(`Error al subir la imagen ${i + 1}`);
        }

        const data = await res.json();
        uploadedSlides.push({
          url: data.url,
          caption: img.caption,
        });
      }

      // Generate HTML
      let slidesHtml = "";
      uploadedSlides.forEach((slide) => {
        const captionHtml = slide.caption.trim()
          ? `\n      <div class="journal-carousel-caption">${slide.caption.trim()}</div>`
          : "";
        slidesHtml += `    <div class="journal-carousel-slide">
      <img src="${slide.url}" alt="${slide.caption.trim() || "diapositiva"}" />${captionHtml}
    </div>\n`;
      });

      const carouselHtml = `\n<div class="journal-carousel">
  <div class="journal-carousel-track">
\n${slidesHtml}  </div>
  <button type="button" class="journal-carousel-btn prev-btn" aria-label="Anterior">‹</button>
  <button type="button" class="journal-carousel-btn next-btn" aria-label="Siguiente">›</button>
  <div class="journal-carousel-dots"></div>
</div>\n`;

      onInsert(carouselHtml);
      onClose();
    } catch (err) {
      console.error(err);
      setError("Ocurrió un error al subir alguna de las imágenes. Por favor, intenta de nuevo.");
    } finally {
      setUploading(false);
      setUploadProgress("");
    }
  };

  useEffect(() => {
    return () => {
      images.forEach((img) => {
        if (img.preview) URL.revokeObjectURL(img.preview);
      });
    };
  }, [images]);

  return (
    <div className="admin-form-overlay" style={{ zIndex: 1010 }} onClick={onClose}>
      <div className="admin-form-box" style={{ maxWidth: 500 }} onClick={(e) => e.stopPropagation()}>
        <h4 style={{ marginBottom: 16, fontFamily: "var(--font-heading)" }}>Insertar Carrusel de Fotos</h4>

        <div className="admin-form">
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: "0.8rem" }}>Seleccionar imágenes *</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleAddImages}
              disabled={uploading}
            />
          </div>

          {images.length > 0 && (
            <div style={{
              maxHeight: "250px",
              overflowY: "auto",
              border: "1px solid var(--clr-sand)",
              borderRadius: "6px",
              padding: "10px",
              marginBottom: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "10px"
            }}>
              {images.map((img, idx) => (
                <div key={img.id} style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "center",
                  paddingBottom: "10px",
                  borderBottom: idx === images.length - 1 ? "none" : "1px solid var(--clr-sand)"
                }}>
                  <img src={img.preview} alt="preview" style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "cover",
                    borderRadius: "4px",
                    border: "1px solid var(--clr-sand)"
                  }} />
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px" }}>
                    <input
                      type="text"
                      placeholder="Pie de foto..."
                      value={img.caption}
                      onChange={(e) => handleCaptionChange(img.id, e.target.value)}
                      style={{ fontSize: "0.8rem", padding: "4px 8px" }}
                      disabled={uploading}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                    <button
                      type="button"
                      onClick={() => handleMove(idx, -1)}
                      disabled={idx === 0 || uploading}
                      style={{ fontSize: "0.75rem", padding: "2px", background: "none", border: "none", cursor: "pointer", color: "var(--clr-bark)" }}
                    >
                      ▲
                    </button>
                    <button
                      type="button"
                      onClick={() => handleMove(idx, 1)}
                      disabled={idx === images.length - 1 || uploading}
                      style={{ fontSize: "0.75rem", padding: "2px", background: "none", border: "none", cursor: "pointer", color: "var(--clr-bark)" }}
                    >
                      ▼
                    </button>
                  </div>
                  <button
                    type="button"
                    className="admin-delete-btn"
                    onClick={() => handleRemoveImage(img.id)}
                    style={{ padding: "4px 8px", fontSize: "0.8rem", margin: 0 }}
                    disabled={uploading}
                  >
                    Eliminar
                  </button>
                </div>
              ))}
            </div>
          )}

          {error && <p style={{ color: "var(--clr-error)", fontSize: "0.85rem", marginBottom: "12px" }}>⚠ {error}</p>}
          {uploadProgress && <p style={{ color: "var(--clr-accent)", fontSize: "0.85rem", fontWeight: "bold", marginBottom: "12px" }}>{uploadProgress}</p>}

          <div className="admin-form-actions" style={{ marginTop: 16 }}>
            <button
              type="button"
              className="admin-cancel-btn"
              onClick={onClose}
              disabled={uploading}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="admin-save-btn"
              onClick={handleSubmit}
              disabled={uploading || images.length === 0}
            >
              {uploading ? "Subiendo..." : "Insertar Carrusel"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Double Image Modal Helper ────────────────────────────────
function DoubleImageModal({ onInsert, onClose, API, adminToken }) {
  const [imgLeft, setImgLeft] = useState({ file: null, preview: "", caption: "" });
  const [imgRight, setImgRight] = useState({ file: null, preview: "", caption: "" });
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleSelectLeft = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (imgLeft.preview) URL.revokeObjectURL(imgLeft.preview);
      setImgLeft((prev) => ({
        ...prev,
        file,
        preview: URL.createObjectURL(file),
      }));
    }
  };

  const handleSelectRight = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (imgRight.preview) URL.revokeObjectURL(imgRight.preview);
      setImgRight((prev) => ({
        ...prev,
        file,
        preview: URL.createObjectURL(file),
      }));
    }
  };

  const handleSubmit = async () => {
    if (!imgLeft.file || !imgRight.file) {
      setError("Debes seleccionar ambas imágenes.");
      return;
    }

    setUploading(true);
    setError("");

    try {
      // Upload left image
      const fdLeft = new FormData();
      fdLeft.append("file", imgLeft.file);
      const resLeft = await fetch(`${API}/api/upload`, {
        method: "POST",
        headers: { Authorization: `Bearer ${adminToken}` },
        body: fdLeft,
      });

      if (!resLeft.ok) throw new Error("Error al subir la imagen izquierda");
      const dataLeft = await resLeft.json();

      // Upload right image
      const fdRight = new FormData();
      fdRight.append("file", imgRight.file);
      const resRight = await fetch(`${API}/api/upload`, {
        method: "POST",
        headers: { Authorization: `Bearer ${adminToken}` },
        body: fdRight,
      });

      if (!resRight.ok) throw new Error("Error al subir la imagen derecha");
      const dataRight = await resRight.json();

      // Generate captions HTML
      const leftCaptionHtml = imgLeft.caption.trim()
        ? `\n    <div class="journal-double-image-caption">${imgLeft.caption.trim()}</div>`
        : "";
      const rightCaptionHtml = imgRight.caption.trim()
        ? `\n    <div class="journal-double-image-caption">${imgRight.caption.trim()}</div>`
        : "";

      const doubleImageHtml = `\n<div class="journal-double-image">
  <div class="journal-double-image-item">
    <img src="${dataLeft.url}" alt="${imgLeft.caption.trim() || "imagen izquierda"}" />${leftCaptionHtml}
  </div>
  <div class="journal-double-image-item">
    <img src="${dataRight.url}" alt="${imgRight.caption.trim() || "imagen derecha"}" />${rightCaptionHtml}
  </div>
</div>\n`;

      onInsert(doubleImageHtml);
      onClose();
    } catch (err) {
      console.error(err);
      setError("Ocurrió un error al subir alguna de las imágenes.");
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (imgLeft.preview) URL.revokeObjectURL(imgLeft.preview);
      if (imgRight.preview) URL.revokeObjectURL(imgRight.preview);
    };
  }, [imgLeft.preview, imgRight.preview]);

  return (
    <div className="admin-form-overlay" style={{ zIndex: 1010 }} onClick={onClose}>
      <div className="admin-form-box" style={{ maxWidth: 500 }} onClick={(e) => e.stopPropagation()}>
        <h4 style={{ marginBottom: 16, fontFamily: "var(--font-heading)" }}>Insertar 2 Fotos Lado a Lado</h4>

        <div className="admin-form">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>Imagen Izquierda *</label>
              <input type="file" accept="image/*" onChange={handleSelectLeft} disabled={uploading} />
              {imgLeft.preview && (
                <img src={imgLeft.preview} alt="izquierda" style={{
                  width: "100%",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "4px",
                  border: "1px solid var(--clr-sand)"
                }} />
              )}
              <input
                type="text"
                placeholder="Pie de foto..."
                value={imgLeft.caption}
                onChange={(e) => setImgLeft({ ...imgLeft, caption: e.target.value })}
                style={{ fontSize: "0.8rem", padding: "4px 8px" }}
                disabled={uploading}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>Imagen Derecha *</label>
              <input type="file" accept="image/*" onChange={handleSelectRight} disabled={uploading} />
              {imgRight.preview && (
                <img src={imgRight.preview} alt="derecha" style={{
                  width: "100%",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "4px",
                  border: "1px solid var(--clr-sand)"
                }} />
              )}
              <input
                type="text"
                placeholder="Pie de foto..."
                value={imgRight.caption}
                onChange={(e) => setImgRight({ ...imgRight, caption: e.target.value })}
                style={{ fontSize: "0.8rem", padding: "4px 8px" }}
                disabled={uploading}
              />
            </div>
          </div>

          {error && <p style={{ color: "var(--clr-error)", fontSize: "0.85rem", marginBottom: "12px" }}>⚠ {error}</p>}

          <div className="admin-form-actions" style={{ marginTop: 16 }}>
            <button
              type="button"
              className="admin-cancel-btn"
              onClick={onClose}
              disabled={uploading}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="admin-save-btn"
              onClick={handleSubmit}
              disabled={uploading || !imgLeft.file || !imgRight.file}
            >
              {uploading ? "Subiendo..." : "Insertar Fotos"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Downloadable Form Modal ───────────────────────────────────
function DownloadableForm({ downloadable, onSave, onCancel }) {
  const [form, setForm] = useState({
    title: downloadable?.title || "",
    description: downloadable?.description || "",
    fileType: downloadable?.fileType || "Modelo 3D",
    link: downloadable?.file && downloadable.file.startsWith("http") ? downloadable.file : "",
  });
  const [file, setFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) {
      setError("El título es obligatorio.");
      return;
    }
    if (!downloadable && !file && !form.link.trim()) {
      setError("Debe subir un archivo o proporcionar un enlace externo.");
      return;
    }
    setSaving(true);
    setError("");

    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => {
      if (k !== "link") fd.append(k, v);
    });
    if (form.link.trim()) fd.append("link", form.link.trim());
    if (file) fd.append("file", file);
    if (previewImage) fd.append("previewImage", previewImage);

    const result = await onSave(fd);
    if (!result.ok) setError(result.message || "Error al guardar");
    setSaving(false);
  };

  return (
    <div className="admin-form-overlay" onClick={onCancel}>
      <div className="admin-form-box" onClick={(e) => e.stopPropagation()}>
        <h3>{downloadable ? "Editar descargable" : "Nuevo descargable"}</h3>
        <form className="admin-form" onSubmit={handleSubmit}>
          <div>
            <label>Título *</label>
            <input name="title" value={form.title} onChange={handleChange} placeholder="Ej: Silla Mecedora - Modelo 3D" />
          </div>
          <div>
            <label>Tipo de archivo *</label>
            <select name="fileType" value={form.fileType} onChange={handleChange}>
              <option value="Modelo 3D">Modelo 3D</option>
              <option value="Catálogo PDF">Catálogo PDF</option>
              <option value="Otro">Otro</option>
            </select>
          </div>
          <div>
            <label>Descripción</label>
            <textarea name="description" value={form.description} onChange={handleChange} placeholder="Breve descripción del archivo…" rows={3} />
          </div>
          <div>
            <label>Imagen de previsualización (Foto)</label>
            <input type="file" accept="image/*" onChange={(e) => setPreviewImage(e.target.files[0])} />
          </div>
          <div>
            <label>Enlace externo (si no sube un archivo)</label>
            <input 
              name="link" 
              value={form.link} 
              onChange={handleChange} 
              placeholder="Ej: https://sketchfab.com/models/..." 
            />
          </div>
          <div>
            <label>Archivo descargable {downloadable ? "(Dejar en blanco para conservar el actual)" : "(Opcional si usó enlace externo)"}</label>
            <input type="file" onChange={(e) => setFile(e.target.files[0])} />
          </div>

          {error && <p style={{ color: "var(--clr-error)", fontSize: "0.85rem" }}>⚠ {error}</p>}

          <div className="admin-form-actions">
            <button type="button" className="admin-cancel-btn" onClick={onCancel}>Cancelar</button>
            <button type="submit" className="admin-save-btn" disabled={saving}>
              {saving ? "Guardando…" : "Guardar descargable"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ─── Products Tab ─────────────────────────────────────────
function ProductsTab() {
  const { products, createProduct, updateProduct, deleteProduct, reorderProducts, API } = useData();
  const [form, setForm] = useState(null); // null | 'new' | product object
  const [isReordering, setIsReordering] = useState(false);

  const resolveImg = (src) => {
    if (!src) return null;
    if (src.startsWith("http")) return src;
    return `${API}${src}`;
  };

  const handleSave = async (fd) => {
    if (form === "new") {
      const r = await createProduct(fd);
      if (r.ok) setForm(null);
      return r;
    } else {
      const r = await updateProduct(form.id, fd);
      if (r.ok) setForm(null);
      return r;
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Eliminar este producto?")) await deleteProduct(id);
  };

  const handleMoveUp = async (index) => {
    if (index === 0 || isReordering) return;
    setIsReordering(true);
    const newProducts = [...products];
    const temp = newProducts[index];
    newProducts[index] = newProducts[index - 1];
    newProducts[index - 1] = temp;

    const ids = newProducts.map((p) => p.id);
    const res = await reorderProducts(ids);
    if (!res.ok) {
      alert("Error al reordenar productos: " + (res.message || "error desconocido"));
    }
    setIsReordering(false);
  };

  const handleMoveDown = async (index) => {
    if (index === products.length - 1 || isReordering) return;
    setIsReordering(true);
    const newProducts = [...products];
    const temp = newProducts[index];
    newProducts[index] = newProducts[index + 1];
    newProducts[index + 1] = temp;

    const ids = newProducts.map((p) => p.id);
    const res = await reorderProducts(ids);
    if (!res.ok) {
      alert("Error al reordenar productos: " + (res.message || "error desconocido"));
    }
    setIsReordering(false);
  };

  return (
    <div>
      <div className="admin-section-header">
        <h2>Productos</h2>
        <button className="admin-add-btn" onClick={() => setForm("new")}>
          + Nuevo producto
        </button>
      </div>

      <div className="admin-list">
        {products.length === 0 && (
          <div className="empty-state">
            <h3>Sin productos</h3>
            <p>Agrega tu primer producto.</p>
          </div>
        )}
        {products.map((p, index) => (
          <div key={p.id} className="admin-item">
            <div className="admin-reorder-actions">
              <button
                type="button"
                className="admin-reorder-btn"
                title="Mover arriba"
                onClick={() => handleMoveUp(index)}
                disabled={index === 0 || isReordering}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m18 15-6-6-6 6"/>
                </svg>
              </button>
              <button
                type="button"
                className="admin-reorder-btn"
                title="Mover abajo"
                onClick={() => handleMoveDown(index)}
                disabled={index === products.length - 1 || isReordering}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m6 9 6 6 6-6"/>
                </svg>
              </button>
            </div>

            <img src={resolveImg(p.image)} alt={p.name} className="admin-item-img"
              onError={(e) => { e.target.style.background = "var(--clr-sand)"; e.target.src = ""; }} />
            <div className="admin-item-info">
              <h4>{p.name}</h4>
              <p>{p.price} {p.featured ? "· ⭐ Destacado" : ""}</p>
            </div>
            <div className="admin-item-actions">
              <button className="admin-edit-btn" onClick={() => setForm(p)}>Editar</button>
              <button className="admin-delete-btn" onClick={() => handleDelete(p.id)}>Eliminar</button>
            </div>
          </div>
        ))}
      </div>

      {form !== null && (
        <ProductForm
          product={form === "new" ? null : form}
          onSave={handleSave}
          onCancel={() => setForm(null)}
        />
      )}
    </div>
  );
}

// ─── Blog Tab ─────────────────────────────────────────────
function BlogTab() {
  const { posts, createPost, updatePost, deletePost, API } = useData();
  const [form, setForm] = useState(null);

  const resolveImg = (src) => {
    if (!src) return null;
    if (src.startsWith("http")) return src;
    return `${API}${src}`;
  };

  const handleSave = async (fd) => {
    if (form === "new") {
      const r = await createPost(fd);
      if (r.ok) setForm(null);
      return r;
    } else {
      const r = await updatePost(form.id, fd);
      if (r.ok) setForm(null);
      return r;
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Eliminar esta publicación?")) await deletePost(id);
  };

  const formatDate = (d) => {
    try { return new Date(d).toLocaleDateString("es-DO", { year: "numeric", month: "short", day: "numeric" }); }
    catch { return d; }
  };

  return (
    <div>
      <div className="admin-section-header">
        <h2>Journal</h2>
        <button className="admin-add-btn" onClick={() => setForm("new")}>
          + Nueva publicación
        </button>
      </div>

      <div className="admin-list">
        {posts.length === 0 && (
          <div className="empty-state">
            <h3>Sin publicaciones</h3>
            <p>Agrega tu primera publicación.</p>
          </div>
        )}
        {posts.map((p) => (
          <div key={p.id} className="admin-item">
            <img src={resolveImg(p.coverImage)} alt={p.title} className="admin-item-img"
              onError={(e) => { e.target.style.background = "var(--clr-sand)"; e.target.src = ""; }} />
            <div className="admin-item-info">
              <h4>{p.title}</h4>
              <p>{formatDate(p.date)} · {p.author}</p>
            </div>
            <div className="admin-item-actions">
              <button className="admin-edit-btn" onClick={() => setForm(p)}>Editar</button>
              <button className="admin-delete-btn" onClick={() => handleDelete(p.id)}>Eliminar</button>
            </div>
          </div>
        ))}
      </div>

      {form !== null && (
        <PostForm
          post={form === "new" ? null : form}
          onSave={handleSave}
          onCancel={() => setForm(null)}
        />
      )}
    </div>
  );
}

function HomepageTab() {
  const { homepage, updateHomepage, API } = useData();
  const [form, setForm] = useState(null);
  const [heroList, setHeroList] = useState([]);
  const [aboutImages, setAboutImages] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (homepage && !form) {
      setForm({
        heroTitle: homepage.hero?.title || "",
        heroSubtitle: homepage.hero?.subtitle || "",
        heroCtaText: homepage.hero?.ctaText || "",
        aboutTitle: homepage.about?.title || "",
        aboutHeadline: homepage.about?.headline || "",
        aboutBody: homepage.about?.body || "",
        aboutReadMoreText: homepage.about?.readMoreText || "",
        aboutReadMoreContent: homepage.about?.readMoreContent || "",
        newsletterTitle: homepage.newsletter?.title || "",
        newsletterSubtitle: homepage.newsletter?.subtitle || "",
        contactEmail: homepage.contact?.email || "",
        contactPhone: homepage.contact?.phone || "",
        contactInstagram: homepage.contact?.instagram || "",
      });

      const initialHero = (homepage.hero?.images || []).map((img, idx) => {
        if (typeof img === "object") {
          return { id: `existing-${idx}`, type: "existing", url: img.url, position: img.position || "center" };
        }
        return { id: `existing-${idx}`, type: "existing", url: img, position: "center" };
      });
      setHeroList(initialHero);
    }
  }, [homepage]);

  // Clean up object URLs to prevent memory leaks
  useEffect(() => {
    return () => {
      heroList.forEach(item => {
        if (item.type === "new" && item.preview) {
          URL.revokeObjectURL(item.preview);
        }
      });
    };
  }, [heroList]);

  if (!form) return <div className="loading-spinner"><div className="spinner" /></div>;

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleAddHeroImages = (e) => {
    const files = Array.from(e.target.files);
    const newItems = files.map((file, idx) => {
      const uniqueId = `new-${Date.now()}-${idx}-${Math.random()}`;
      return {
        id: uniqueId,
        type: "new",
        file: file,
        preview: URL.createObjectURL(file),
        position: "center"
      };
    });
    setHeroList((prev) => [...prev, ...newItems]);
    e.target.value = "";
  };

  const handleDeleteHeroImage = (id) => {
    setHeroList((prev) => {
      const item = prev.find((i) => i.id === id);
      if (item && item.type === "new" && item.preview) {
        URL.revokeObjectURL(item.preview);
      }
      return prev.filter((i) => i.id !== id);
    });
  };

  const handleUpdatePosition = (id, newPos) => {
    setHeroList((prev) =>
      prev.map((item) => (item.id === id ? { ...item, position: newPos } : item))
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSaved(false);
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));

    // Construct metadata and append files
    const metadata = [];
    let fileIdx = 0;
    heroList.forEach((item) => {
      if (item.type === "existing") {
        metadata.push({
          type: "existing",
          url: item.url,
          position: item.position
        });
      } else if (item.type === "new") {
        metadata.push({
          type: "new",
          fileIndex: fileIdx,
          position: item.position
        });
        fd.append("heroImages", item.file);
        fileIdx++;
      }
    });
    fd.append("heroImagesMetadata", JSON.stringify(metadata));

    aboutImages.forEach((img) => fd.append("aboutImages", img));
    if (logoFile) fd.append("logo", logoFile);
    const r = await updateHomepage(fd);
    setSaving(false);
    if (r.ok) setSaved(true);
  };

  const Field = ({ label, name, type = "text", rows }) => (
    <div>
      <label>{label}</label>
      {rows ? (
        <textarea name={name} value={form[name]} onChange={handleChange} rows={rows} />
      ) : (
        <input type={type} name={name} value={form[name]} onChange={handleChange} />
      )}
    </div>
  );

  return (
    <div>
      <div className="admin-section-header">
        <h2>Página principal</h2>
      </div>

      {saved && (
        <div className="save-success-banner" style={{ marginBottom: 24 }}>
          ✓ Cambios guardados exitosamente
        </div>
      )}

      <form className="homepage-admin-form" onSubmit={handleSave}>
        {/* General Settings (Logo) */}
        <div className="admin-form-section">
          <h3>⚙️ Configuración General</h3>
          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "var(--clr-bark)", letterSpacing: "0.5px", textTransform: "uppercase", display: "block", marginBottom: 8 }}>
              Logo de la página (Header)
            </label>
            {homepage?.logo && (
              <div style={{ marginBottom: 8 }}>
                <span style={{ fontSize: "0.85rem", color: "var(--clr-bark-light)" }}>Logo actual: </span>
                <a 
                  href={`${API}${homepage.logo}`} 
                  target="_blank" 
                  rel="noreferrer"
                  style={{ fontSize: "0.85rem", color: "var(--clr-earth)", textDecoration: "underline" }}
                >
                  Ver logo
                </a>
              </div>
            )}
            <input type="file" accept="image/*" onChange={(e) => setLogoFile(e.target.files[0])} />
          </div>
        </div>

        {/* Hero */}
        <div className="admin-form-section">
          <h3>🖼 Hero (portada)</h3>
          <div className="admin-form admin-form-row">
            <Field label="Título" name="heroTitle" />
            <Field label="Subtítulo" name="heroSubtitle" />
            <Field label="Texto del botón" name="heroCtaText" />
          </div>
          <div style={{ marginTop: 20 }}>
            <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "var(--clr-bark)", letterSpacing: "0.5px", textTransform: "uppercase", display: "block", marginBottom: 12 }}>
              Imágenes del carrusel (Hero)
            </label>

            {heroList.length > 0 ? (
              <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginBottom: 16 }}>
                {heroList.map((item, idx) => {
                  const previewSrc = item.type === "existing" ? `${API}${item.url}` : item.preview;
                  return (
                    <div 
                      key={item.id} 
                      style={{ 
                        width: "150px", 
                        background: "var(--clr-white)", 
                        border: "1px solid var(--clr-sand)", 
                        borderRadius: "8px", 
                        padding: "10px", 
                        display: "flex", 
                        flexDirection: "column", 
                        gap: "8px", 
                        position: "relative" 
                      }}
                    >
                      {item.type === "new" && (
                        <span style={{ 
                          position: "absolute", 
                          top: "14px", 
                          left: "14px", 
                          background: "var(--clr-success)", 
                          color: "white", 
                          fontSize: "0.6rem", 
                          fontWeight: 600, 
                          padding: "2px 6px", 
                          borderRadius: "4px" 
                        }}>
                          NUEVO
                        </span>
                      )}
                      <img 
                        src={previewSrc} 
                        alt={`Slide ${idx + 1}`} 
                        style={{ width: "100%", height: "90px", objectFit: "cover", borderRadius: "6px" }}
                      />
                      
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                        <span style={{ fontSize: "0.7rem", fontWeight: 600, color: "var(--clr-earth)" }}>Alineación:</span>
                        <select
                          value={item.position}
                          onChange={(e) => handleUpdatePosition(item.id, e.target.value)}
                          style={{ 
                            fontSize: "0.75rem", 
                            padding: "4px", 
                            borderRadius: "4px", 
                            border: "1px solid var(--clr-sand)",
                            background: "var(--clr-cream)",
                            cursor: "pointer",
                            width: "100%"
                          }}
                        >
                          <option value="center">Centro</option>
                          <option value="top">Arriba (Superior)</option>
                          <option value="bottom">Abajo (Inferior)</option>
                          <option value="left">Izquierda</option>
                          <option value="right">Derecha</option>
                        </select>
                      </div>

                      <button
                        type="button"
                        onClick={() => handleDeleteHeroImage(item.id)}
                        style={{
                          background: "#ffebee",
                          color: "#c62828",
                          border: "none",
                          fontSize: "0.75rem",
                          fontWeight: 500,
                          padding: "6px 0",
                          borderRadius: "4px",
                          cursor: "pointer",
                          transition: "background 0.2s",
                          width: "100%",
                          textAlign: "center"
                        }}
                        onMouseEnter={(e) => e.target.style.background = "#ffcdd2"}
                        onMouseLeave={(e) => e.target.style.background = "#ffebee"}
                      >
                        Eliminar
                      </button>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p style={{ fontSize: "0.85rem", color: "var(--clr-bark-light)", marginBottom: 12 }}>No hay imágenes en el carrusel.</p>
            )}

            <div style={{ marginTop: 12 }}>
              <label 
                style={{ 
                  display: "inline-block", 
                  cursor: "pointer", 
                  background: "var(--clr-accent)", 
                  color: "white", 
                  padding: "8px 16px", 
                  borderRadius: "4px", 
                  fontSize: "0.85rem", 
                  fontWeight: 500,
                  transition: "background 0.2s"
                }}
                onMouseEnter={(e) => e.target.style.background = "var(--clr-earth)"}
                onMouseLeave={(e) => e.target.style.background = "var(--clr-accent)"}
              >
                ➕ Añadir imágenes al carrusel
                <input 
                  type="file" 
                  accept="image/*" 
                  multiple 
                  onChange={handleAddHeroImages} 
                  style={{ display: "none" }} 
                />
              </label>
            </div>
          </div>
        </div>

        {/* About */}
        <div className="admin-form-section">
          <h3>📖 Sección "Sobre nosotros"</h3>
          <div className="admin-form">
            <div className="admin-form-row">
              <Field label="Título" name="aboutTitle" />
              <Field label="Subtítulo" name="aboutHeadline" />
            </div>
            <Field label="Cuerpo del texto" name="aboutBody" rows={4} />
            <Field label="Texto del botón 'Leer más'" name="aboutReadMoreText" />
            <Field label="Contenido expandido" name="aboutReadMoreContent" rows={5} />
            <div style={{ marginTop: 16 }}>
              <label style={{ fontSize: "0.8rem", fontWeight: 600, color: "var(--clr-bark)", letterSpacing: "0.5px", textTransform: "uppercase", display: "block", marginBottom: 8 }}>
                Imágenes de la sección (reemplaza las actuales)
              </label>
              {(homepage?.about?.images || (homepage?.about?.image ? [homepage.about.image] : [])).length > 0 && (
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: 8 }}>
                  {(homepage?.about?.images || (homepage?.about?.image ? [homepage.about.image] : [])).map((imgUrl, idx) => (
                    <div key={idx} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <img 
                        src={`${API}${imgUrl}`} 
                        alt={`Sobre nosotros ${idx + 1}`} 
                        style={{ width: "80px", height: "60px", objectFit: "cover", borderRadius: "4px", border: "1px solid var(--clr-sand)" }}
                      />
                      <span style={{ fontSize: "0.7rem", color: "var(--clr-bark-light)", marginTop: "2px" }}>#{idx + 1}</span>
                    </div>
                  ))}
                </div>
              )}
              <input type="file" accept="image/*" multiple onChange={(e) => setAboutImages([...e.target.files])} />
            </div>
          </div>
        </div>

        {/* Newsletter */}
        <div className="admin-form-section">
          <h3>📧 Newsletter</h3>
          <div className="admin-form admin-form-row">
            <Field label="Título" name="newsletterTitle" />
            <Field label="Subtítulo" name="newsletterSubtitle" />
          </div>
        </div>

        {/* Contact */}
        <div className="admin-form-section">
          <h3>📞 Contacto (Footer)</h3>
          <div className="admin-form">
            <div className="admin-form-row">
              <Field label="Correo electrónico" name="contactEmail" type="email" />
              <Field label="Teléfono" name="contactPhone" />
            </div>
            <Field label="URL de Instagram" name="contactInstagram" />
          </div>
        </div>

        <button type="submit" className="admin-save-homepage-btn" disabled={saving}>
          {saving ? "Guardando…" : "Guardar todos los cambios"}
        </button>
      </form>
    </div>
  );
}

// ─── Downloadables Tab ─────────────────────────────────────
function DownloadablesTab() {
  const { downloadables, createDownloadable, updateDownloadable, deleteDownloadable, API } = useData();
  const [form, setForm] = useState(null); // null | 'new' | downloadable object

  const resolveImg = (src) => {
    if (!src) return null;
    if (src.startsWith("http")) return src;
    return `${API}${src}`;
  };

  const handleSave = async (fd) => {
    if (form === "new") {
      const r = await createDownloadable(fd);
      if (r.ok) setForm(null);
      return r;
    } else {
      const r = await updateDownloadable(form.id, fd);
      if (r.ok) setForm(null);
      return r;
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Eliminar este archivo descargable?")) {
      await deleteDownloadable(id);
    }
  };

  return (
    <div>
      <div className="admin-section-header">
        <h2>Descargables</h2>
        <button className="admin-add-btn" onClick={() => setForm("new")}>
          + Nuevo descargable
        </button>
      </div>

      <div className="admin-list">
        {downloadables.length === 0 && (
          <div className="empty-state">
            <h3>Sin descargables</h3>
            <p>Agrega tu primer archivo descargable (catálogos, modelos 3D, etc.).</p>
          </div>
        )}
        {downloadables.map((item) => (
          <div key={item.id} className="admin-item">
            <img 
              src={resolveImg(item.previewImage)} 
              alt={item.title} 
              className="admin-item-img"
              onError={(e) => { 
                e.target.style.background = "var(--clr-sand)"; 
                e.target.src = ""; 
              }} 
            />
            <div className="admin-item-info">
              <h4>{item.title}</h4>
              <p>{item.fileType} · <span style={{ fontSize: "0.85rem", color: "var(--clr-bark-light)" }}>{item.fileName || "Archivo"}</span></p>
            </div>
            <div className="admin-item-actions">
              <button className="admin-edit-btn" onClick={() => setForm(item)}>Editar</button>
              <button className="admin-delete-btn" onClick={() => handleDelete(item.id)}>Eliminar</button>
            </div>
          </div>
        ))}
      </div>

      {form !== null && (
        <DownloadableForm
          downloadable={form === "new" ? null : form}
          onSave={handleSave}
          onCancel={() => setForm(null)}
        />
      )}
    </div>
  );
}

// ─── Main Admin Panel ─────────────────────────────────────
export default function AdminPanel() {
  const { adminToken, logout } = useData();
  const [tab, setTab] = useState("products");
  const [loggedIn, setLoggedIn] = useState(!!adminToken);

  useEffect(() => {
    setLoggedIn(!!adminToken);
  }, [adminToken]);

  if (!loggedIn) {
    return <AdminLogin onLogin={() => setLoggedIn(true)} />;
  }

  const tabs = [
    { id: "products", label: "Productos", icon: "📦" },
    { id: "blog", label: "Journal", icon: "✍️" },
    { id: "homepage", label: "Página principal", icon: "🏠" },
    { id: "downloadables", label: "Descargables", icon: "📁" },
  ];

  return (
    <div className="admin-panel">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-logo">
          enramá<span>Admin Panel</span>
        </div>

        {tabs.map((t) => (
          <button
            key={t.id}
            className={`admin-nav-btn ${tab === t.id ? "active" : ""}`}
            onClick={() => setTab(t.id)}
          >
            <span>{t.icon}</span>
            {t.label}
          </button>
        ))}

        <button
          className="admin-logout-btn"
          onClick={() => { logout(); setLoggedIn(false); }}
        >
          <span>↩</span> Cerrar sesión
        </button>
      </aside>

      {/* Main content */}
      <main className="admin-main">
        {tab === "products" && <ProductsTab />}
        {tab === "blog" && <BlogTab />}
        {tab === "homepage" && <HomepageTab />}
        {tab === "downloadables" && <DownloadablesTab />}
      </main>
    </div>
  );
}
